import { Component, OnInit } from '@angular/core';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { LogViewerService } from 'src/services/log-viewer.service';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';


@Component({
    selector: 'app-log-viewer',
    templateUrl: './log-viewer.component.html',
    styleUrls: ['./log-viewer.component.scss']
})
export class LogViewerComponent implements OnInit {
    logs: any[] = [];
    loading = false;
    totalRecords = 0;
    currentPage = 1;
    pageSize = 10;

    constructor(
        private breadcrumbService: AppBreadcrumbService,
        private logViewerService: LogViewerService,
        private messageService: MessageService
    ) {
        this.breadcrumbService.setItems([
            { label: 'Log Viewer', routerLink: ['/logs'] }
        ]);
    }

    ngOnInit(): void {
    
}
    loadLogs(): void {
        this.loading = true;
        this.logViewerService.getLogs(this.currentPage, this.pageSize).subscribe(
            (res) => {
                this.logs = (res?.data ?? []).map((log) => ({
                    ...log,
                    displayMessage: this.toDisplayMessage(log?.message)
                }));
                this.totalRecords = res?.totalCount ?? 0;
                this.loading = false;
            },
            () => {
                this.loading = false;
                this.messageService.add({
                    key: 'bc',
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load application logs.'
                });
            }
        );
    }

    onPageChange(event: LazyLoadEvent): void {
    this.pageSize = event.rows ?? 50;
    this.currentPage = Math.floor((event.first ?? 0) / this.pageSize) + 1;
    this.loadLogs();
}

    clear(table: Table): void {
        table.clear();
    }

    private toDisplayMessage(message: string): string {
    if (!message) {
        return '';
    }

    const trimmed = message.trim();
    if (!trimmed.startsWith('{')) {
        return trimmed;
    }

    try {
        const parsed = JSON.parse(trimmed);

        const api = parsed?.api
            || parsed?.summary?.api
            || parsed?.endpoint
            || `${parsed?.request?.method ?? parsed?.method ?? ''} ${parsed?.request?.path ?? parsed?.apiPath ?? ''}${parsed?.request?.queryString ?? ''}`.trim();

        const exceptionMessage = parsed?.exceptionType
            || parsed?.summary?.message
            || parsed?.exception?.message
            || parsed?.message
            || '';

        if (api && exceptionMessage) {
            return `${api} | Exception: ${exceptionMessage}`;
        }

        if (api) {
            return api;
        }

        if (exceptionMessage) {
            return exceptionMessage;
        }
    } catch {
        // keep raw message when not valid JSON
    }

    return trimmed;
   }
}